<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.625 6.39286L6.125 9.89286M6.125 9.89286L9.625 6.39286M6.125 9.89286V1" stroke="currentColor" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
    <line x1="11.6" y1="11.4178" x2="0.4" y2="11.4178" stroke="currentColor" stroke-width="0.8" stroke-linecap="round"/>
</svg>
